import {FC} from 'react'

import {CONTAINER_PADDING_MOBILE} from '@/theme/sizing'
import {theme} from '@/theme/theme'

export const ComparisonTableMobileHeader: FC<React.PropsWithChildren<unknown>> = ({children}) => (
  <>
    <div className="comparison-table-header">{children}</div>

    {/* Global styles are used only because the children are defined in separate components */}
    <style jsx global>{`
      .comparison-table-header {
        display: flex;
        position: sticky;
        top: 0;
        background-color: ${theme.palette.background.default};
        margin: 0 -${CONTAINER_PADDING_MOBILE} -${theme.spacing[2]};
        padding: ${theme.spacing[2]} ${CONTAINER_PADDING_MOBILE};
        z-index: 1;
      }
      .comparison-table-header > div {
        flex: 1;
        position: relative;
        padding-bottom: calc(${theme.spacing[3]} - ${theme.spacing[1]});
      }
      .comparison-table-header div + div {
        margin-left: ${theme.spacing[2]};
      }
      .comparison-table-header > div::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: ${theme.palette.gray[900]};
        height: 4px;
        border-radius: 4px;
        z-index: 1;
      }
    `}</style>
  </>
)
